class CsrfTokenResolver
{
    fetchTokenPromise = null;

    findInMetaTag() {
        // `document` is undefined in some contexts, e.g. service worker
        if (typeof document === 'undefined') {
            return false;
        }

        const metaCsrfTokenTag = document.querySelector('meta[name="csrf-token"]');

        if (metaCsrfTokenTag) {
            this.saveToken(metaCsrfTokenTag.getAttribute('content'));
            return true;
        }

        return false;
    }

    requestToken() {
        return fetch('/csrf-token', {method: 'POST'})
            .then((response) => {
                return response.json();
            }).then((data) => {
                return data.token;
            }).then((token) => {
                this.saveToken(token);
                return token;
            });
    }

    saveToken(csrfToken) {
        global.csrfToken = csrfToken;
        this.onResolved(global.csrfToken);
    }

    resolve() {
        if (typeof global.csrfToken !== 'undefined' || this.findInMetaTag()) {
            return new Promise(resolve => {
                resolve(global.csrfToken);
                this.onResolved(global.csrfToken);
            });
        }

        if (this.fetchTokenPromise === null) {
            this.fetchTokenPromise = this.requestToken();
        }

        return this.fetchTokenPromise;
    }

    refresh() {
        this.fetchTokenPromise = this.requestToken();

        return this.fetchTokenPromise;
    }

    onResolved(token) {
        // `document` is undefined in some contexts, e.g. service worker
        if (typeof document === 'undefined') {
            return;
        }

        const event = new CustomEvent('csrfTokenResolved', {token: token});
        document.dispatchEvent(event);
    }
}

const csrfTokenResolver = new CsrfTokenResolver();

export default csrfTokenResolver;
